import apiClient from '@/services/axios'

import { CUSTOM_PAGE_SETTINGS_FIELD } from '@/constants/custom-pages'

const getDefaultState = () => ({
  selectedLanguage: 'ru',
  form: {
    ru: CUSTOM_PAGE_SETTINGS_FIELD,
  },
  isCustomThemeModalVisible: false,
  customThemes: [],
})

export default {
  namespaced: true,
  state: getDefaultState(),
  mutations: {
    SET_SELECTED_LANGUAGE(state, lang) {
      state.selectedLanguage = lang
    },

    SET_MODAL_VISIBLE(state, value) {
      state.isCustomThemeModalVisible = value
    },
    SET_FORM(state, form) {
      state.form = JSON.parse(JSON.stringify(form))
    },
    SET_CUSTOM_THEMES(state, data) {
      state.customThemes = data
    },
    RESET_STATE(state) {
      Object.assign(state, getDefaultState())
    },
  },
  actions: {
    setSelectedLanguage({ commit }, lang) {
      commit('SET_SELECTED_LANGUAGE', lang)
    },

    setIsModalVisible({ commit }, value) {
      commit('SET_MODAL_VISIBLE', value)
    },

    setCurrentForm({ commit, state }, data) {
      const formCopy = JSON.parse(JSON.stringify(state.form))
      const selectedLanguage = state.selectedLanguage

      commit('SET_FORM', {
        ...formCopy,
        [selectedLanguage]: data,
      })
    },
    setLangForm({ commit, state }, { data, lang }) {
      const formCopy = JSON.parse(JSON.stringify(state.form))

      commit('SET_FORM', {
        ...formCopy,
        [lang]: data,
      })
    },

    initForm({ commit, rootGetters }) {
      const langs = rootGetters['langs']?.langData

      if (langs.length === 0) {
        commit('SET_FORM', {
          ru: { ...CUSTOM_PAGE_SETTINGS_FIELD },
        })

        return
      }

      const form = langs.reduce((acc, lang) => {
        return {
          ...acc,
          [lang.name]: { ...CUSTOM_PAGE_SETTINGS_FIELD },
        }
      }, {})

      commit('SET_FORM', form)
    },

    async fillSettings({ commit, state, dispatch, rootGetters }, data) {
      await dispatch('getLangs', null, { root: true })

      const formCopy = JSON.parse(JSON.stringify(state.form))

      const langs = rootGetters['langs']?.langData

      const settingsForm = {}

      data.settings.map((setting) => {
        const langName = langs.find((l) => setting.lid === l.id)?.name ?? 'ru'

        settingsForm[langName] = {
          theme: setting.id,
          matchTheme: 'inherit',
          schema: setting.schema,
          headerButton: {
            overlaySchema: setting.overlay_schema,
            textColor: setting.banner_text_color,
            bgColor: setting.banner_background_color,
          },
          main: {
            mainColor: setting.main_color,
            fill: setting.fill,
            bgColor: setting.background_color,
            overlayColor: setting.overlay_color,
            textColor: setting.text_color,
            iconColor: setting.icon_color,
          },
          filter: {
            activeColor: setting.active_color,
            contentColor: setting.content_on_active_color,
          },
        }
      })

      commit('SET_FORM', { ...formCopy, ...settingsForm })
    },

    async fetchThemes({ commit }) {
      try {
        const resp = await apiClient.get('/admin/custom-page/themes')
        if (resp?.data?.data) {
          commit('SET_CUSTOM_THEMES', resp?.data?.data)
        }
      } catch (e) {
        console.error(e)
      }
    },
  },
  getters: {
    selectedLanguage: (state) => state.selectedLanguage,
    form: (state) => state.form,
    currentForm: (state) => state.form[state.selectedLanguage] || {},
    isCustomThemeModalVisible: (state) => state.isCustomThemeModalVisible,
    customThemes: (state) => state.customThemes,
  },
}
